var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7512 0H18.818L12.1179 7.65773L20 18.0782H13.8284L8.99456 11.7582L3.46356 18.0782H0.394939L7.56129 9.88737L0 0H6.32826L10.6976 5.77667L15.7512 0ZM14.6748 16.2425H16.3742L5.40488 1.73921H3.5813L14.6748 16.2425Z",
    fill: "#7BC0EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/footer_twitter.273a1f7fe5738b61e84c731a66bf0216.svg";
export { ForwardRef as ReactComponent };